let ipAddress: string;

export const setIpAddress = (value: string) => (ipAddress = value);

export const getIpAddress = () => ipAddress;
